import { render, staticRenderFns } from "./DataImportReport.vue?vue&type=template&id=ce246d56&"
import script from "./DataImportReport.vue?vue&type=script&lang=ts&"
export * from "./DataImportReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports